module.exports = __WEBPACK_EXTERNAL_MODULE_228__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Subject"
// module id = 228
// module chunks = 0